import { getIsFileList } from './utils';
import type { UploaderCreateOptions, BatchItem, Batch } from '../types';
import { BATCH_STATES } from '../consts';
import createBatchItem from '../batch-Item';

let bCounter = 0;

const processFiles = (
  batchId: string,
  files: BatchItem | BatchItem[],
  isPending: boolean
): Promise<BatchItem[]> => {
  return Promise.all<any[]>(
    Array.prototype.map.call(files, (f) => {
      return f;
    })
  ).then((filtered) => filtered.filter(Boolean).map((f) => createBatchItem(f, batchId, isPending)));
};

const createBatch = (
  files: BatchItem | BatchItem[],
  uploaderId: string,
  options: UploaderCreateOptions
): Promise<Batch> => {
  bCounter += 1;
  const id = `batch-${bCounter}`;

  const isFileList = getIsFileList(files);

  files = Array.isArray(files) || isFileList ? files : [files];

  const isPending = !options.autoUpload;

  return processFiles(id, files, isPending).then((items) => {
    return {
      id,
      uploaderId,
      items,
      state: isPending ? BATCH_STATES.PENDING : BATCH_STATES.ADDED,
      completed: 0,
      loaded: 0,
      orgItemCount: items.length,
      additionalInfo: '',
    };
  });
};

export default createBatch;
